export const API_URL = 'https://api-erp.technext.ao/api';